import { TEMPLATE_LANGUAGE, TEMPLATE_TYPE } from '../constants/messageTemplateKeys';

const defaultSendConditions = () => [{ sendCondition: '', day: '' }];

const DEFAULT_FORM = {
  templateName: '',
  type: TEMPLATE_TYPE.MARKETING,
  language: TEMPLATE_LANGUAGE.ENGLISH,
  subjects: [''],
  selectedCampaignIds: [],
  selectedTagIds: [],
  triggerId: '',
  sendConditions: defaultSendConditions(),
};

export function mapTemplateToBasicInfoForm(template) {
  if (!template) return DEFAULT_FORM;

  const subjects = Array.isArray(template.subjects)
    ? template.subjects
        .map((subject) => String(subject?.text ?? '').trim())
        .filter((subject) => subject.length > 0)
    : [];

  const triggerEntries = Array.isArray(template.triggers) ? template.triggers : [];
  const firstTriggerId = triggerEntries[0]?.trigger?.id;

  return {
    templateName: String(template.name ?? ''),
    type:
      String(template.type ?? TEMPLATE_TYPE.MARKETING) === TEMPLATE_TYPE.TRIGGER
        ? TEMPLATE_TYPE.TRIGGER
        : TEMPLATE_TYPE.MARKETING,
    language: String(template.language ?? TEMPLATE_LANGUAGE.ENGLISH),
    subjects: subjects.length > 0 ? subjects : [''],
    selectedCampaignIds: Array.isArray(template.campaigns)
      ? template.campaigns.map((item) => String(item?.id ?? '')).filter((id) => id.length > 0)
      : [],
    selectedTagIds: Array.isArray(template.tags)
      ? template.tags.map((item) => String(item?.id ?? '')).filter((id) => id.length > 0)
      : [],
    triggerId:
      firstTriggerId != null && String(firstTriggerId).trim().length > 0
        ? String(firstTriggerId)
        : '',
    sendConditions:
      triggerEntries.length > 0
        ? triggerEntries.map((entry) => ({
            sendCondition: String(entry?.send_condition ?? ''),
            day: entry?.day != null ? String(entry.day) : '',
          }))
        : defaultSendConditions(),
  };
}
